import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { ludingtonConfig } from "./data";

export default function LudingtonPage() {
  return <CityPageTemplate config={ludingtonConfig} />;
}